// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__bYepM","Menu":"SiderContentC_Menu__WfhE5"};